import { render } from "./AllContacts.vue?vue&type=template&id=2f47ac21&scoped=true"
import script from "./AllContacts.vue?vue&type=script&lang=js"
export * from "./AllContacts.vue?vue&type=script&lang=js"

import "./AllContacts.vue?vue&type=style&index=0&id=2f47ac21&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f47ac21"]])

export default __exports__